<script setup lang="ts">
import { inject } from "vue";

import routeManager from "@/router/route-manager";
import { labelServiceSymbol } from "@/plugins/LabelServicePlugin";

import type { LabelService } from "@/composables/label-service";

const labelService = inject<LabelService>( labelServiceSymbol ) as LabelService;

function hideMenuOnBlur( event: MouseEvent ) {
  if ( event.target ) {
    ( event.target as Element ).removeAttribute( "open" );
  }
}

function showMenuOnFocus( event: Event ) {
  if ( event.target ) {
    ( event.target as Element ).setAttribute( "open", "" );
  }
}
</script>

<template>
  <details @mouseenter="showMenuOnFocus" @mouseleave="hideMenuOnBlur" class="header-menu dropdown dropdown-end dropdown-hover">
    <summary class="btn btn-sm btn-ghost text-base-content uppercase text-s">
      <i class="pi pi-question-circle lg:inline"></i>
      <span class="hidden lg:inline items-center gap-2 text-base-content text-s">{{ labelService.label( 'lblSupport' ) }}</span>
    </summary>
    <ul class="menu dropdown-content w-min-58" @click="hideMenuOnBlur">
      <li>
        <router-link :to="routeManager.appStatusPath()">
          <i class="pi pi-flag"><span class="ml-2 text-lg">{{ labelService.label( 'lblAppStatus' ) }}</span></i>
        </router-link>
      </li>
      <li>
        <router-link :to="routeManager.featureNewsPath()">
          <i class="pi pi-megaphone"><span class="ml-2 text-lg">{{ labelService.label( 'lblFeatureNews' ) }}</span></i>
        </router-link>
      </li>
      <li>
        <router-link :to="routeManager.contactUsPath()">
          <i class="pi pi-phone"><span class="ml-2 text-lg">{{ labelService.label( 'lblContactUs' ) }}</span></i>
        </router-link>
      </li>
      <li>
        <router-link :to="routeManager.whitelistInstructionsPath()">
          <i class="pi pi-list-check"><span class="ml-2 text-lg">{{ labelService.label( 'lblWhitelistInstructions' ) }}</span></i>
        </router-link>
      </li>
      <li>
        <router-link :to="routeManager.appToolsPath()">
          <i class="pi pi-eraser"><span class="ml-2 text-lg">{{ labelService.label( 'lblReset' ) }}</span></i>
        </router-link>
      </li>
    </ul>
  </details>
</template>
